import React, {Component} from "react";
import "./index.scss";
import {deinitButton, initButton} from "services/google/auth";

interface GoogleButtonProps {
  onLoggedIn?: ()=>void;
  disabled?: boolean;
}

export default class GoogleButton extends Component<GoogleButtonProps> {
  componentWillUnmount() {
    deinitButton(this.onLoggedIn);
  }

  private onButtonRendered = (element:HTMLDivElement|null) => {
    if(element) {
      initButton(element, this.onLoggedIn, 300);
    }
  };

  onLoggedIn = () => {
    if(this.props.onLoggedIn) {
      this.props.onLoggedIn();
    }
  };

  render() {
    const disabled = !!this.props.disabled;
    return <div className={`google-login-button ${disabled ? 'disabled' : ''}`} ref={this.onButtonRendered} />;
  }
}
